import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { Providers } from './containers/providers';
import './modules/sentry';
import { Router } from './router';
import { installDynamicImportReloadHandler } from './utils/dynamic-import-reload';

installDynamicImportReloadHandler();

const fallbackError = (
  <div className="p-6 text-center">
    <h1 className="text-xl font-semibold">Something went wrong</h1>
    <p className="mt-2 text-sm opacity-80">Please refresh the page and try again.</p>
  </div>
);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={fallbackError}>
      <Providers>
        <Router />
      </Providers>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
